import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, watchEffect, watch, toRaw, ref, onMounted } from 'vue'
import { cloneDeep, isEqual } from 'lodash-es'
import { Form } from 'ant-design-vue'
import CosDateTimeRagePicker from '@/components/CosDateTimeRagePicker/index.vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import BusinessName from '@/components/BusinessName/index.vue'
import { remindTypeEnum } from '../dataConfig'
import { listByParamCodes } from '@/api/common'
import { businessSelectListByRefId } from '@/api/yuntuSales/chanceManage'
import { customerContactList } from '@/api/yuntuSales/customerCenter'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
import dayjs from 'dayjs'


const __default__ = { name: 'VisitorProgramForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: Object,
  title: String,
  saleChanceRefId: [String, Number], // 客户id，当传入有值的时候需要设置客户名称不可选
  isEdit: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: 'add'
  }
},
  emits: ['update:value'],
  setup(__props, { expose: __expose, emit: __emit }) {

const useForm = Form.useForm

const props = __props

const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  lbu_follow_purpose: [], // 拜访目的
  lbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_purpose', 'lbu_follow_mode']
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
onMounted(() => {
  if (dataForm.startTime === undefined) {
    dataForm.startTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
    dataForm.endTime = dataForm.startTime
  }
  getByParamCodes()
})

const dataForm = reactive<LbuVisitorProgramEditParams>({
  visitRefId: undefined,
  title: undefined,
  mode: undefined,
  startTime: undefined,
  purpose: undefined,
  contactId: undefined,
  remindType: 1,
  remindTime: undefined
})
const isOtherTime = ref(false) // 是否其它时间
const formRules = reactive({
  visitRefId: [{ required: true, message: '请选择客户名称' }],
  title: [{ required: true, message: '请输入计划标题' }],
  mode: [{ required: true, validator: selectForNumberValidate, message: '请选择拜访方式' }],
  startTime: [{ required: true, message: '请选择拜访时间' }],
  purpose: [{ required: true, validator: selectForNumberValidate, message: '请选择拜访目的' }],
  contactId: [{ required: true, validator: selectForNumberValidate, message: '请选择联系人' }],
  remindType: [{ required: true, validator: selectForNumberValidate, message: '请选择访客提醒' }],
  remindTime: [{ required: isOtherTime, message: '请选择提醒时间' }]
})

// 获取关联商机
const chanceEnum = ref<any[]>([])
const getChanceEnum = (id: string) => {
  businessSelectListByRefId(id).then((res) => {
    chanceEnum.value = res.data
  })
}
// 获取联系人
const contactEnum = ref<any[]>([])
const getContactEnum = (id: string) => {
  const params = { contactRefId: id, pageNumber: 1, pageSize: 200 }
  customerContactList(params).then((res) => {
    contactEnum.value = res.data.items
  })
}
const handleCustomerNameChange = (value?: any) => {
  dataForm.chanceName = undefined
  dataForm.chanceId = undefined
  dataForm.contactId = undefined
  setTimeout(() => clearValidate(['contactId']), 0)
  if (!value) {
    chanceEnum.value = []
    contactEnum.value = []
  }
}
const handleContactChange = (value?: any) => {
  dataForm.contactName = value ? contactEnum.value.find((e) => e.id === value)?.name : undefined
}
const handleChanceChange = (value?: any) => {
  dataForm.chanceName = value ? chanceEnum.value.find((e) => e.chanceId === value)?.label : undefined
}

const emit = __emit
watchEffect(() => {
  if (!props.value) return
  // 如果值相同则不更新
  const isSame = isEqual(toRaw(dataForm), toRaw(props.value))
  if (isSame) return
  const clone = cloneDeep(props.value)
  Object.assign(dataForm, clone)
})
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)
// 回显数据监听客户名称变化
watch(
  () => dataForm.visitRefId,
  (val) => {
    if (val) {
      getChanceEnum(val)
      getContactEnum(val)
    }
  },
  { immediate: true }
)
// 详情页面回显时，当联系人已经被删除时需要特殊处理
watch(
  () => dataForm.contactId,
  (val) => {
    if (props.type === 'view' && val) {
      const hasContact = contactEnum.value.some((e) => e.id === val)
      if (!hasContact) dataForm.contactId = dataForm.contactName
    }
  }
)

// 监听判断“提醒时间”是否必填
// 当访客提醒选择其他时间时，“提醒时间”字段必填
watch(
  () => dataForm.remindType,
  (val) => {
    setTimeout(() => clearValidate(['remindTime']), 0)
    isOtherTime.value = val === 4
    if (val && val !== 4) dataForm.remindTime = undefined
  },
  { immediate: true }
)

const { resetFields, validate, clearValidate, validateInfos } = useForm(dataForm, formRules)
__expose({ resetFields, validate })

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, { scrollToFirstError: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_card, {
        title: props.title,
        span: 6
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, _mergeProps({ label: "客户名称" }, _unref(validateInfos).visitRefId), {
            default: _withCtx(() => [
              _createVNode(ClueAndCustomerSelect, {
                appId: "cos_lbu",
                value: dataForm.visitRefId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.visitRefId) = $event)),
                label: dataForm.customerName,
                "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.customerName) = $event)),
                disabled: !props.isEdit || !!props.saleChanceRefId,
                view: props.type === 'view',
                onChange: handleCustomerNameChange
              }, null, 8, ["value", "label", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          (props.type === 'view')
            ? (_openBlock(), _createBlock(_component_dc_form_item, {
                key: 0,
                label: "客户ID"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosInput, {
                    value: dataForm.visitRefId,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.visitRefId) = $event)),
                    view: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "计划标题" }, _unref(validateInfos).title), {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.title,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.title) = $event)),
                valueModifiers: { trim: true },
                maxlength: 100,
                disabled: !props.isEdit,
                view: props.type === 'view'
              }, null, 8, ["value", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "拜访方式" }, _unref(validateInfos).mode), {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.mode,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.mode) = $event)),
                options: paramCodeData.lbu_follow_mode,
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "计划拜访时间" }, _unref(validateInfos).startTime), {
            default: _withCtx(() => [
              _createVNode(CosDateTimeRagePicker, {
                startTime: dataForm.startTime,
                "onUpdate:startTime": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.startTime) = $event)),
                endTime: dataForm.endTime,
                "onUpdate:endTime": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.endTime) = $event)),
                disabled: !props.isEdit,
                view: props.type === 'view',
                minuteStep: 15
              }, null, 8, ["startTime", "endTime", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "拜访目的" }, _unref(validateInfos).purpose), {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.purpose,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.purpose) = $event)),
                options: paramCodeData.lbu_follow_purpose,
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "联系人" }, _unref(validateInfos).contactId), {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.contactId,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.contactId) = $event)),
                fieldNames: { label: 'name', value: 'id' },
                options: contactEnum.value,
                disabled: !props.isEdit,
                allowClear: "",
                view: props.type === 'view',
                onChange: handleContactChange
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, { label: "关联商机" }, {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.chanceId,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.chanceId) = $event)),
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: "",
                onChange: handleChanceChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chanceEnum.value, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.chanceId,
                      value: item.chanceId
                    }, {
                      default: _withCtx(() => [
                        _createVNode(BusinessName, {
                          appId: "cos_lbu",
                          label: item.label,
                          "onUpdate:label": ($event: any) => ((item.label) = $event),
                          value: item.saleChanceName,
                          "onUpdate:value": ($event: any) => ((item.saleChanceName) = $event)
                        }, null, 8, ["label", "onUpdate:label", "value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "disabled", "view"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "访客提醒" }, _unref(validateInfos).remindType), {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.remindType,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.remindType) = $event)),
                options: _unref(remindTypeEnum),
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          (isOtherTime.value)
            ? (_openBlock(), _createBlock(_component_dc_form_item, _mergeProps({
                key: 1,
                label: "提醒时间"
              }, _unref(validateInfos).remindTime), {
                default: _withCtx(() => [
                  (props.type !== 'view')
                    ? (_openBlock(), _createBlock(_component_a_date_picker, {
                        key: 0,
                        style: {"width":"100%"},
                        value: dataForm.remindTime,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.remindTime) = $event)),
                        format: "YYYY/MM/DD HH:mm:ss",
                        "value-format": "YYYY/MM/DD HH:mm:ss",
                        "show-time": "",
                        disabled: !props.isEdit,
                        placeholder: "请选择"
                      }, null, 8, ["value", "disabled"]))
                    : (_openBlock(), _createBlock(CosInputView, {
                        key: 1,
                        value: dataForm.remindTime
                      }, null, 8, ["value"]))
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true),
          (props.type === 'view')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_dc_form_item, { label: "创建人" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createByName,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.createByName) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createTime,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.createTime) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "更新人" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.updateByName,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.updateByName) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "更新时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.updateTime,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.updateTime) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_a_col, { span: 24 }),
          _createVNode(_component_dc_form_item, {
            label: "备注",
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.remark,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.remark) = $event)),
                maxlength: 2000,
                disabled: !props.isEdit,
                view: props.type === 'view'
              }, null, 8, ["value", "disabled", "view"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})